import { Component, OnInit } from '@angular/core';

interface Client {
  name: string;
  logo: string;
  description?: string;
  website?: string;
}

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {

  clients: Client[] = [
    {
      name: 'AlToque',
      logo: 'assets/logos/cliente-altoque.png',
      description: 'Aplicación móvil para administracion de negocios de venta, distribucion y servicios',
      website: 'https://play.google.com/store/apps/details?id=com.raven1205.altoque&hl=es_PE'
    },
    {
      name: 'Hinaqui',
      logo: 'assets/logos/cliente-hinaqui.svg',
      description: 'Empresa especialista en productos industriales de fibra de vidrio.',
      website: 'https://hinaqui.com/'
    },
    {
      name: 'Esserge',
      logo: 'assets/logos/cliente-esserge.png',
      description: 'Empresa especialista en el manejo de plagas',
      website: 'https://esserge.com/'
    },
    {
      name: 'Cafu Company S.a.C.',
      logo: 'assets/logos/cliente-cafu.png',
      description: 'Empresa especializada en publicidad para negocios y emprendedores.',
      website: 'https://cafucompany.pe/'
    },
    // Agrega más clientes según sea necesario
  ];

  constructor() { }

  ngOnInit(): void {
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/icons/company-placeholder.svg';
  }

}
